import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import Resources from "@/pages/Resources";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/case-studies" element={<CaseStudies />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/privacy" element={<Legal kind="privacy" />} />
                    <Route path="/cookies" element={<Legal kind="cookies" />} />
                    <Route path="/terms" element={<Legal kind="terms" />} />
                    <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    richColors
                    closeButton
                    toastOptions={{
                        style: {
                            background: "#0F0F0F",
                            border: "1px solid rgba(255,255,255,0.08)",
                            color: "#fff",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
